import { trigger, transition, style, animate } from '@angular/animations';

export const slideInAnimation = trigger('routeAnimations', [
  transition('* <=> *', [
    style({ position: 'absolute', opacity: 0 }),
    animate('300ms ease-out', style({ opacity: 1 })),
  ]),
]);
